import React, {useState} from "react";
import {
    IonLabel,
    IonInput,
    IonIcon
} from '@ionic/react';
import {closeCircle, alertCircle} from 'ionicons/icons';


const WrapperIonInput = (
    {
        type = 'text',
        label = '',
        placeholder = '',
        value = '',
        Change = () => {},
        Click = () => {},
        required = false,
        disabled = false,
        error = false,
        info = '',
        enterkeyhint = undefined
    }
) => {
    const [focus, setFocus] = useState(false);

    return <>
        <div className={`i-input ${focus ? 'i-input-focus' : ''} ${error ? 'i-input_error' : ''} ${disabled ? 'i-input_disabled' : ''}`}>
            {label && <IonLabel position="stacked" mode="ios" className="i-label i-label_black i-label_min">
                {label}
            </IonLabel>}
            <div className="i-input-wrap">
                <IonInput
                    mode="ios"
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={required}
                    disabled={disabled}
                    onIonChange={e => Change(e.target.value)}
                    onClick={Click}
                    onIonFocus={() => setFocus(true)}
                    onIonBlur={() => setFocus(false)}
                    enterkeyhint={enterkeyhint}
                />
                {value && !error && <div className="i-input-icon" onClick={() => Change('')}>
                    <IonIcon slot="icon-only" icon={closeCircle} className="close-circle" />
                </div>}
                {error && <div className="i-input-icon">
                    <IonIcon slot="icon-only" icon={alertCircle} className="alert-circle" />
                </div>}
            </div>
            <div className="i-input-info">
                {info}
            </div>
        </div>
    </>
};


export default WrapperIonInput;